export default ({ hrefLang, data }, { t }) => {
  if (!data) {
    return {};
  }

  const { campaign } = data;

  const title = campaign
    ? campaign.facetted.seoTitle
    : t('campaigns', 'themes.title');
  const description = campaign
    ? campaign.facetted.seoDescription
    : t('campaigns', 'themes.description');
  const campaignLogoBanner =
    campaign && campaign.banners && campaign.banners.length > 0
      ? campaign.banners.find(
          item => item.type.toUpperCase() === 'BANNER_LOGO_BIG'
        )
      : undefined;
  const campaignImage = campaignLogoBanner
    ? campaignLogoBanner.imageUrl
    : undefined;

  const canonical = campaign ? campaign.facetted.canonical : undefined;

  const openGraph = campaign && [
    { key: 'title', content: title },
    { key: 'description', content: description },
    { key: 'url', content: canonical },
    campaignImage && { key: 'image', content: campaignImage },
    { key: 'type', content: 'website' },
  ];

  let structuredData = [];
  if (campaign) {
    const structuredDataCampaign = {
      '@context': 'http://schema.org',
      '@type': 'Thing',
      name: title,
      description: campaign.description.page,
      url: canonical,
    };
    if (campaignImage) {
      structuredDataCampaign.image = campaignImage;
    }

    structuredData = [structuredDataCampaign];
  }

  return {
    title,
    description,
    canonical,
    openGraph,
    structuredData,
    hrefLang: campaign
      ? campaign.hrefLang
      : Object.keys(hrefLang.campaignMain).map(locale => ({
          locale,
          url: hrefLang.campaignMain[locale],
        })),
  };
};
